export default "/build/static/fonts/Whitney-Book_Web.woff2";